<span #label [appDropdownDirective]="info" [label]="label" (keydown.enter)="emitirClick()" (click)="emitirClick()" [originX]="originX" [originY]="originY" [overlayX]="overlayX" [overlayY]="overlayY ">
    <ng-content select="[trigger]"></ng-content>
</span>
<ng-template #info>
    <span *ngIf="!leaveModalOpen;else noOpen" (keydown.enter)="emitirClick()" (click)="emitirClick()">
            <ng-content select="[close]"></ng-content>
        </span>
    <ng-template #noOpen>
        <ng-content select="[open]"></ng-content>
    </ng-template>
</ng-template>
